import actions, { LOGIN_BUSINESS_ACCOUNT, LOGOUT } from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  phone: '',
  avatar: '',
  authorized: '' || false, // false is default value
  loading: false,
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    case LOGIN_BUSINESS_ACCOUNT:
      localStorage.setItem('profile', JSON.stringify(action.payload))
      return { ...state, ...action.payload }

    case LOGOUT:
      localStorage.setItem('profile', JSON.stringify(null))
      return {
        ...action.payload,
        authData: null,
      }
    default:
      const profile = JSON.parse(localStorage.getItem('profile'))
      return {
        ...state,
        ...profile,
      }
  }
}
